// Utility function to clear the organisation details tab session storage
// This should be called when navigating to the organisation details page from other parts of the app
export const clearOrganisationDetailsTabStorage = () => {
  sessionStorage.removeItem('organisation-details-active-tab');
};
